/* eslint-disable react/destructuring-assignment */
import React from "react";

export const NewEmailIcon = props => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M15.625 17.5V12.5M13.125 15H18.125M18.125 5.625V10M18.125 5.625C18.125 5.29348 17.9933 4.97554 17.7589 4.74112C17.5245 4.5067 17.2065 4.375 16.875 4.375H3.125C2.79348 4.375 2.47554 4.5067 2.24112 4.74112C2.0067 4.97554 1.875 5.29348 1.875 5.625M18.125 5.625L10.7113 10.7575C10.5023 10.9021 10.2541 10.9796 10 10.9796C9.74585 10.9796 9.49774 10.9021 9.28875 10.7575L1.875 5.625M1.875 5.625V14.375C1.875 14.7065 2.0067 15.0245 2.24112 15.2589C2.47554 15.4933 2.79348 15.625 3.125 15.625H9.375"
      stroke={props.color || "#94A3B8"}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const NewFolderIcon = props => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10 15.833H4.16667C3.72464 15.833 3.30072 15.6574 2.98816 15.3449C2.67559 15.0323 2.5 14.6084 2.5 14.1663V4.99967C2.5 4.55765 2.67559 4.13372 2.98816 3.82116C3.30072 3.5086 3.72464 3.33301 4.16667 3.33301H7.5L10 5.83301H15.8333C16.2754 5.83301 16.6993 6.0086 17.0118 6.32116C17.3244 6.63372 17.5 7.05765 17.5 7.49967V10.4163M13.3333 15.833H18.3333M15.8333 13.333V18.333"
      stroke={props.color || "#94A3B8"}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LeafIcon = props => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.2301 14.166C3.4076 3.78695 10.7601 0.842807 16.6442 1.8528C16.8825 5.29278 15.1992 6.58027 11.9942 7.17526C12.6125 7.82192 13.7067 8.63609 13.5884 9.65358C13.505 10.3769 13.0134 10.7327 12.03 11.4427C9.87506 12.9994 7.37841 13.9827 4.2301 14.166Z"
      stroke={props.color || "#94A3B8"}
      strokeWidth="1.04167"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.3335 18.3329C3.3335 12.9163 6.54014 10.1513 8.75012 8.33301"
      stroke={props.color || "#94A3B8"}
      strokeWidth="1.04167"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ExpandIcon = props => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M11.6666 3.33301H16.6666M16.6666 3.33301V8.33301M16.6666 3.33301L11.6666 8.33301M8.33325 16.6663H3.33325M3.33325 16.6663V11.6663M3.33325 16.6663L8.33325 11.6663"
      stroke={props.color || "#94A3B8"}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const CollpseIcon = props => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M16.6667 8.33301L11.6667 8.33301M11.6667 8.33301L11.6667 3.33301M11.6667 8.33301L14.1667 5.83301L16.6667 3.33301"
      stroke={props.color || "#94A3B8"}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 12H9M9 12V17M9 12L6.5 14.5L4 17"
      stroke={props.color || "#94A3B8"}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const AiStarsIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clipPath="url(#clip0_16962_10576)">
      <path
        d="M5.33301 10.0007C8.58301 10.0007 9.99967 8.63332 9.99967 5.33398C9.99967 8.63332 11.4063 10.0007 14.6663 10.0007C11.4063 10.0007 9.99967 11.4073 9.99967 14.6673C9.99967 11.4073 8.58301 10.0007 5.33301 10.0007ZM1.33301 4.33398C3.42234 4.33398 4.33301 3.45532 4.33301 1.33398C4.33301 3.45532 5.23767 4.33398 7.33301 4.33398C5.23767 4.33398 4.33301 5.23865 4.33301 7.33398C4.33301 5.23865 3.42234 4.33398 1.33301 4.33398Z"
        fill={props.color || "#64748B"}
        stroke={props.color || "#64748B"}
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_16962_10576">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
